import { Icon } from 'components/Icon';
import { HTMLAttributes } from 'react';
import styled from 'styled-components';

interface Props {
    staticColor?: string;
    width?: number;
    height?: number;
    zIndex?: number;
    isLoading?: boolean;
    disableLink?: boolean;
}

const Loader = styled.span<Props>`
    display: block;
    position: relative;
    width: ${({ width }) => width}px;
    height: ${({ width, height }) => height || width}px;
    border-radius: 50%;
    background: linear-gradient(45deg, white, white 40%, #38c172);
    animation: ${(p) => (p.staticColor ? null : 'animate 1s ease-in-out infinite')};

    &:before {
        content: '';
        position: absolute;
        top: ${({ width }) => width / 25}px;
        bottom: ${({ width }) => width / 25}px;
        left: ${({ width, height }) => (height || width) / 25}px;
        right: ${({ width, height }) => (height || width) / 25}px;
        background: #fff;
        border-radius: 50%;
        z-index: 1;
    }

    &:after {
        content: '';
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        background: ${(p) => p.staticColor || 'linear-gradient(45deg, white, white 40%, #38c172)'};
        border-radius: 50%;
        filter: blur(3px);
    }

    @keyframes animate {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

const LoaderWrapper = styled.a<Props>`
    text-align: left;
    position: relative;
    width: ${({ width }) => width}px;
    height: ${({ width, height }) => height || width}px;
    z-index: ${({ zIndex }) => zIndex || 'unset'};

    svg {
        position: absolute;
        z-index: 2;
        margin: ${({ width }) => width / 10}px;
    }
`;

export const LogoLoader = ({
    width = 50,
    isLoading = true,
    staticColor,
    disableLink,
    ...props
}: Props & HTMLAttributes<HTMLAnchorElement>) => {
    return (
        // @ts-ignore
        <LoaderWrapper href={disableLink ? null : '/'} {...props} width={width}>
            <Icon />
            {(staticColor || isLoading) && <Loader staticColor={staticColor} width={width} />}
        </LoaderWrapper>
    );
};

export default LogoLoader;
